<template>

    <div class="p-3">

        <button type="button" class="btn btn-outline-otu border rounded ml-2 float-right" v-b-modal.modalCreateFolder v-b-tooltip :title="$t('messages.new_folder')">
            <font-awesome-icon :icon="['fas', 'folder-plus']" />
		</button>

        <h2>{{ $t('messages.manage_folders') }}</h2>

        <div class="table-responsive">
    		<table class="table text-nowrap table-striped table-hover">
			<tbody>
                <tr v-for="folder in folders" :key="folder.id">
					<td width="30"><font-awesome-icon class="mr-3" :icon="['far', 'folder-open']" /></td>
					<td><LiveEdit editClass="form-control form-control-lg auto-w" :text="folder.name" :id="folder.id" @text-updated="renameFolder"></LiveEdit></td>
					<td width="130">{{folder.message_count}} {{ $t('messages.messages_label') }}</td>
					<td width="30"><button type="button" class="btn btn-light border" v-b-modal.modalDeleteFolder @click="deleteFolderId=folder.id"><i class="fa fa-lg fa-trash" aria-hidden="true"></i></button></td>
	  			</tr>
            </tbody>
            </table>
        </div>

        <!-- Modals -->
    	<b-modal id="modalDeleteFolder" :title="$t('messages.delete_folder')" size="md" :ok-title="$t('delete_button')" :cancel-title="$t('cancel_button')" ok-variant="danger" centered @ok="deleteFolder">
    		{{ $t('messages.delete_folder_confirm') }}
    	</b-modal>

    	<b-modal id="modalCreateFolder" :title="$t('messages.create_folder')" size="sm" :ok-title="$t('save_button')" :cancel-title="$t('cancel_button')" centered @ok="createFolder" @shown="setFocus('txtFolderName')">
    		<input type="text" ref="txtFolderName" v-model="newFolderName" :placeholder="$t('messages.new_folder_name')" class="form-control form-control-lg auto-w" />
    	</b-modal>

    </div>

</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler } from '@/lib/handlers.js';

export default {
    name: 'ManageFolders',
    components: {
		LiveEdit: () => import ('@/components/common/LiveEdit.vue')
	},
    data () {
        return {
            deleteFolderId: null,
            newFolderName: null
        }
    },
    mounted() {
        this.fetchFolders();
    },
    computed: {
        folders () {
            if (this.$store.state.messages.folders) {
                return _.filter(this.$store.state.messages.folders, function(f) { return f.parent_folder_id == null && f.type_id == 0 });
            }
        }
    },
    methods: {
        ...mapActions(['fetchFolders', 'fetchMatchings', 'newFolder', 'destroyFolder', 'saveFolder']),
        ...mapNotificationEventActions,
        createFolder  () {
    		this.newFolder({name: this.newFolderName}).then((v) => {
                this.emitSuccess({msg: this.$t('messages.folder_added') });
    			this.newFolderName = null;
    		}).catch( (err) => errHandler(err) );
        },
        deleteFolder  () {
            this.destroyFolder(this.deleteFolderId).then((v) => {
                this.emitSuccess({msg: this.$t('messages.folder_deleted') });
                this.deleteFolderId = null;
            }).catch( (err) => errHandler(err) );
        },
        renameFolder: async function (value, id) {
            this.saveFolder({ folderId: id, name: value}).then((v) => {
                this.emitSuccess({msg: this.$t('messages.folder_saved') });
            }).catch( (err) => errHandler(err) );
        },
        setFocus  (field) {
            this.$refs[`${field}`].focus();
        }
    }
}

</script>
